module.exports = __webpack_public_path__ + "img/color3_on.194eb94a.png";